import { Cubby } from "../stores/Cubby";
import { Task } from "../stores/Task";

// Define a mapping of lifecycle status values for comparison
const lifecycleStatusOrder = {
  initialized: 0,
  starting: 1,
  in_progress: 2,
  completed: 3,
  errored: 4,
};

export const updateTasks = (cubby: Cubby, newTasks: any[]) => {
  if (newTasks.length === 0) {
    return;
  }

  const mostRecentTaskServerPushedAt = newTasks[0].pushed_from_server_timestamp;
  if (cubby.mostRecentTaskServerPushedAt >= mostRecentTaskServerPushedAt) {
    console.log("OUT OF DATE TASKS, RETURN");
    return;
  }
  cubby.updateMostRecentTaskServerPushedAt(mostRecentTaskServerPushedAt);

  for (const newTaskData of newTasks) {
    let foundTask = cubby.tasks.find((task) => task.uuid === newTaskData.uuid);

    if (foundTask) {
      // Check if the new lifecycle status is going backward
      const currentStatusValue =
        lifecycleStatusOrder[foundTask.lifecycleStatus];
      const newStatusValue = lifecycleStatusOrder[newTaskData.lifecycle_status];

      // If the new status is less than the current status, skip the update
      if (newStatusValue < currentStatusValue) {
        console.log(
          `Skipping task update as lifecycle status is going backward for task ${newTaskData.uuid}`
        );
        return;
      }

      console.log("found a task with uuid", newTaskData.uuid);
      foundTask.lifecycleStatus = newTaskData.lifecycle_status;
      foundTask.humanReadableLifecycleStatus =
        newTaskData.human_readable_lifecycle_status;
    }

    if (!foundTask) {
      console.log("creating a new task with uuid", newTaskData.uuid);
      foundTask = new Task({
        createdAtTimestamp: newTaskData.created_at_timestamp,
        uuid: newTaskData.uuid,
        kind: newTaskData.kind,
        humanReadableKind: newTaskData.human_readable_kind,
        lifecycleStatus: newTaskData.lifecycle_status,
        humanReadableLifecycleStatus:
          newTaskData.human_readable_lifecycle_status,
      });
      cubby.tasks.push(foundTask);
    }

    foundTask.maybeSetToFrontendSawTerminalLifecycleStatus();
  }
};
